import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import InputCalendar from '@components/InputCalendar';
import InputSelect from '@components/InputSelect';
import InputText from '@components/InputText';
import { ENDORSEMENT_TYPES } from '@domain/endorsements/constants';

import type { StepProps } from '../types';

export const Step2: FC<StepProps> = ({ control, isReadOnly = false }) => {
  return (
    <>
      <Controller
        control={control}
        name="reference"
        render={({ field, fieldState: { error } }) => (
          <InputText
            {...field}
            isReadOnly={isReadOnly}
            labelText="Endorsement Reference"
            isRequired
            errors={error?.message}
            dataTestId="text:endorsement-reference"
          />
        )}
      />
      <Controller
        control={control}
        name="internal_description"
        render={({ field, fieldState: { error } }) => (
          <InputText
            {...field}
            isReadOnly={isReadOnly}
            labelText="Internal Description"
            errors={error?.message}
            dataTestId="text:endorsement-internal_description"
          />
        )}
      />
      <Controller
        control={control}
        name="type"
        render={({ field, fieldState: { error } }) => (
          <InputSelect
            {...field}
            isReadOnly={isReadOnly}
            isRequired
            isSearchable={false}
            labelText="Endorsement Type"
            options={ENDORSEMENT_TYPES}
            errors={error?.message}
            dataTestId="select:endorsement-type"
            shouldRenderInsidePortal
          />
        )}
      />
      <Controller
        control={control}
        name="effective_date"
        render={({ field, fieldState: { error } }) => (
          <InputCalendar
            {...field}
            isReadOnly={isReadOnly}
            labelText="Effective Date"
            isRequired
            errors={error?.message}
            dataTestId="calendar:endorsement-effective-date"
            shouldRenderInsidePortal
          />
        )}
      />
      <Controller
        control={control}
        name="expiry_date"
        render={({ field, fieldState: { error } }) => (
          <InputCalendar
            {...field}
            isReadOnly={isReadOnly}
            labelText="Expiry Date"
            isRequired
            errors={error?.message}
            dataTestId="calendar:endorsement-expiry-date"
            shouldRenderInsidePortal
          />
        )}
      />
    </>
  );
};
